import React from "react";
import { Link } from "react-router-dom";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import EventsList from "./events-list";

import "./events.scss";

library.add(faCalendarAlt);

function Events() {
  return (
    <div className="events-page">
      <div className="page-content gutter">
        <h1>Live Salt</h1>
        <div className="row title-row">
          <FontAwesomeIcon className="page-icon" icon={faCalendarAlt} />
          <div className="page-copy">
            <p>
              Catch Salty live in the GTA at an upcoming gig. For more
              information, refer to our Facebook {" "}
              <a
                href="https://www.facebook.com/wesaltythree/events/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Events
              </a>{" "}
              page. To book the band go to our{" "}
              <Link reloadDocument to="/contact" target="_self">
                Contact
              </Link>
              {" "} page.
            </p>
          </div>
        </div>
        <div className="row">
          <EventsList />
        </div>
      </div>
    </div>
  );
}

export default Events;
